import React from "react";
import "./AgeVerificationPopup.css";

const AgeVerificationPopup = ({ onYes, onNo, isRejected }) => {
  return (
    <div className="age-overlay">
      <div className="age-box">
        {!isRejected ? (
          <>
            <h2 className="title">Age Verification</h2>
            <h3 className="brand">LushDesire</h3>

            <p className="text">
              This website contains products intended for adults only.
              <br />
              You must be 18 years of age or older to continue.
              <br />
              If you are under 18, please exit this website.
            </p>

            <div className="btn-group">
              <button className="yes-btn" onClick={onYes}>
                Yes, I am 18+
              </button>

              <button className="no-btn" onClick={onNo}>
                No, I am Under 18
              </button>
            </div>
          </>
        ) : (
          <>
            <h3 className="brand">LushDesire</h3>
            <h2 className="sorry">Access Restricted</h2>
            <p className="text">
              Sorry, you must be at least 18 years old to access this website.
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default AgeVerificationPopup;
